import {useQuery} from '@tanstack/react-query';
import {apiClient} from '../../../../lib/api-client';

export const useGetBackOrderedOrders = (productID: number, distributorID: number, enabled: boolean) => {
	const { data, isLoading } = useQuery({
		queryKey: ['backordered-orders', productID, distributorID],
		enabled: enabled,
		queryFn: async () => await apiClient.get('material-order/backordered',
			{
				params: {
					productID,
					distributorID
				}
			}) as []
	});

	return {
		data: data || [],
		isLoading: isLoading
	};
};
